import { ACCOUNTS_NEWS } from "../constants/actionTypes";

interface IErrorReducer {
  type: string;
  error: string;
}

const errorReducer = (state = null, action: IErrorReducer) => {
  switch (action.type) {
    case ACCOUNTS_NEWS.LOAD_FAIL:
      return action.error || state;
    case ACCOUNTS_NEWS.LOAD:
    case ACCOUNTS_NEWS.LOAD_SUCCESS:
      return null;
    default:
      return state;
  }
};

export default errorReducer;
